import { AxiosResponse } from "axios";
import BaseController from "controller/BaseController";
import AddUserRequest from "model/api/AddUserRequest.model";
import AddUserResponse from "model/api/AddUserResponse.model";
import UserService from "service/User.service";
import { ActionType, ViewRenderStatus } from "util/CommonConstant";
import { parseStandardAPIErrorMessage } from "util/CommonUtil";

type IState = any;

class JoinTodayViewController extends BaseController {
  private state: IState;

  constructor(state?: IState, dispatch?: any) {
    super(dispatch); // Call the constructor of the parent class if needed.
    this.state = state ?? null;
    this.dispatch = dispatch;
  }

  init = (email: string, invitationToken: string) => {
    if (email !== "" && invitationToken !== "") {
      this.dispatch({
        type: ActionType.SET_DATA_CHANGE,
        payload: [
          { name: "email", value: email },
          { name: "invitationToken", value: invitationToken },
        ],
      });
    } else {
      this.dispatch({
        type: ActionType.SET_DATA_CHANGE,
        payload: { name: "isEmailOrTokenAbsent", value: true },
      });
    }
  };

  handleAgreementCheck = () => {
    this.dispatch({
      type: ActionType.SET_DATA_CHANGE,
      payload: {
        name: "isAgreementChecked",
        value: !this.state.data?.isAgreementChecked,
      },
    });
    if (!this.state.data?.isAgreementChecked) this.setErrorMessage("");
  };

  //Add user
  addUser = async (isAuth0Enabled: boolean) => {
    try {
      this.setErrorMessage("");
      const payload = new AddUserRequest();
      payload.user = {
        first_name: this.state.data?.firstName ?? "",
        last_name: this.state.data?.lastName ?? "",
        email: this.state.data?.email ?? "",
      };
      payload.password = this.state.data?.password ?? "";
      payload.invite_token = this.state.data?.invitationToken ?? "";

      const res: AxiosResponse<AddUserResponse> = await UserService.create(payload, isAuth0Enabled);
      //If the API error
      if (res.status !== 200 && res.status !== 201) {
        const errorMessage = res.data?.response?.error_message ?? "Something went wrong";
        this.setErrorMessage(errorMessage);
        this.setPageStatus(ViewRenderStatus.ERROR);
        return Promise.reject("Something went wrong");
      }
      //If the API success
      this.dispatch({
        type: ActionType.SET_DATA_CHANGE,
        payload: { name: "isUserJoinedSuccessfully", value: true },
      });
      this.setPageStatus(ViewRenderStatus.SUCCESS);
      return res.data;
    } catch (err) {
      //If the API error
      const errorMessage = parseStandardAPIErrorMessage(err) ?? "Something went wrong";
      this.setErrorMessage(errorMessage);
      this.setPageStatus(ViewRenderStatus.ERROR);
      return Promise.reject(err);
    }
  };
}

export default JoinTodayViewController;
